
const getPaginationLimit = () => {
  if (window.innerWidth === 1280 || window.innerWidth === 800 || window.innerWidth === 736) {
    return 27;
  }
  if (window.innerWidth <= 1600) {
    return 28;
  }
  return 30;
};

export default getPaginationLimit;
